
import React, { useLayoutEffect } from 'react'

import CartItem from './CartItem.jsx'

const CartItems = ({ items, iScrollUpdate }) => {
    useLayoutEffect(() => {
        iScrollUpdate()
    }, [])

    return <div className="happy-cart-small__wrapper">
        <div className="happy-cart-small__list">
            { items.map((item) => {
                return <CartItem
                    key={ `cart-item-${ item.ID }` }
                    item={ item }
                />
            }) }
        </div>
    </div>
}

export default CartItems